import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import userRoleAuthorization from './js/modules/componentUserRole.js'
import userAuthTypeAuthorization from './js/modules/componentUserAuthType.js'
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false
// ユーザーロールによる権限管理：モジュール化している関数をラップし、インスタンスメソッドを追加する（グローバルメソッド）
Vue.prototype.$userRoleAuthorization = (...args) => userRoleAuthorization(store.getters['auth/getRoleId'], ...args);
// ユーザー権限種別による権限管理：モジュール化している関数をラップし、インスタンスメソッドを追加する（グローバルメソッド）
Vue.prototype.$userAuthTypeAuthorization = (...args) => userAuthTypeAuthorization(store.getters['auth/getAuthTypeId'], ...args);

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GTM,
  },
  params: {
    send_page_view: true
  },
}, router);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
